import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';
import { SaveRecipeInput } from '../../../models/SaveRecipeInput';

export class SaveOrderRecipeService extends HttpServiceBase {

  handle = (input: SaveOrderRecipeServiceInput): Promise<Result<SaveOrderRecipeServiceOutput> | null> => {
    const promise = input.recipeId && input.recipeId > 0
      ? this.http.put<Result<SaveOrderRecipeServiceOutput>, SaveOrderRecipeServiceInput>(
        `${this.baseUrlSislogApi}/point-of-sale/order/${input.shopifyOrderId}/recipe/${input.recipeId}?apiKey=${this.getSislogApiKey()}`,
        input)
      : this.http.post<Result<SaveOrderRecipeServiceOutput>, SaveOrderRecipeServiceInput>(
        `${this.baseUrlSislogApi}/point-of-sale/order/${input.shopifyOrderId}/recipe?apiKey=${this.getSislogApiKey()}`,
        input);
    return promise;
  }
}

export class SaveOrderRecipeServiceInput extends SaveRecipeInput {
  shopifyId: number;
  recipeId?: number;
}

export class SaveOrderRecipeServiceOutput {
  saveRecipeResult?: boolean | null;
  updateRecipeResult?: boolean | null;
  changeStateResult?: boolean | null;
}